import { render, staticRenderFns } from "./searchView.component.vue?vue&type=template&id=2dd7a40c&scoped=true&"
import script from "./searchView.component.vue?vue&type=script&lang=js&"
export * from "./searchView.component.vue?vue&type=script&lang=js&"
import style0 from "./searchView.component.vue?vue&type=style&index=0&id=2dd7a40c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7a40c",
  null
  
)

export default component.exports